var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default, withProps = styledComponents.withProps, keyframes = styledComponents.keyframes;
var rotate = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"], ["\n   0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"])));
var spin = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px;\n  }\n"], ["\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px;\n  }\n"])));
var Wrapper = styled.svg(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  animation: ", " 2s linear infinite;\n"], ["\n  animation: ", " 2s linear infinite;\n"])), rotate);
var Circle = withProps(styled.circle)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  stroke-linecap: round;\n  stroke-dasharray: 1; 200;\n  stroke-dashoffset: 0;\n  animation: ", " 1.5s ease-in-out infinite;\n\n  stroke: ", ";\n"], ["\n  stroke-linecap: round;\n  stroke-dasharray: 1; 200;\n  stroke-dashoffset: 0;\n  animation: ", " 1.5s ease-in-out infinite;\n\n  stroke: ",
    ";\n"])), spin, function (props) {
    return props.color ? props.color : props.theme.datashop.palette.blue.main;
});
var Spinner = function (_a) {
    var size = _a.size, color = _a.color, props = __rest(_a, ["size", "color"]);
    var style = {
        height: size + "px",
        width: size + "px",
    };
    var circleProps = {
        cx: 25,
        cy: 25,
        r: 20,
        fill: 'none',
        strokeMiterlimit: '10',
        strokeWidth: '2',
        color: color,
    };
    return (React.createElement(Wrapper, __assign({ viewBox: "0 0 50 50", style: style }, props),
        React.createElement(Circle, __assign({}, circleProps))));
};
Spinner.defaultProps = {
    size: 16,
};
export default Spinner;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Spinner.js.map